import { configureStore as configureToolkitStore } from '@reduxjs/toolkit';

import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import { responsiveStoreEnhancer, calculateResponsiveState } from 'redux-responsive';
import createReducer from './reducers';

import { officeApi } from './services/office';

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState = {}, history) {
  const middlewares = [sagaMiddleware, officeApi.middleware, routerMiddleware(history)];

  const enhancers = [responsiveStoreEnhancer];

  const store = configureToolkitStore({
    reducer: createReducer(),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(
        middlewares
      ),
    enhancers
  });

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.asyncReducers = {};
  window.addEventListener('resize', () =>
    store.dispatch(calculateResponsiveState(window))
  );

  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', () => {
      import('./reducers').then((reducerModule) => {
        const createReducers = reducerModule.default;
        const nextReducers = createReducers(store.asyncReducers);

        store.replaceReducer(nextReducers);
      });
    });
  }

  return store;
}
